export const transformValues = (values, progress) => ({
    regionalAccess: values?.regionalAccess || [],
    apartmentAccess: values?.apartmentAccess || [],
    listingId: values?.listingId,
    completion: Math.round(progress) || 0,
    listingInformation: {
        listingAgreement: values?.listingAgreement,
        listingAgreementDoc: values?.listingAgreementDoc,
        // listingService: values?.listingService,
        listPrice: values?.listPrice?.toString(),
        expirationDate: values?.expirationDate ? new Date(values.expirationDate).toISOString() : undefined,
        housingVouchers: values?.housingVouchers
        // auctionDate: values?.auctionDate ? new Date(values.auctionDate).toISOString() : undefined,
        // specialListingConditions: values?.specialListingConditions
    },
    locationInformation: {
        streetDirPrefix: values?.streetDirPrefix,
        streetDirSuffix: values?.streetDirSuffix,
        // outOfStateCounty: values?.outOfStateCounty,
        // outOfStateCity: values?.OutOfStateCity,
        unit: values?.unitNumber,
        taxLot: values?.taxLot,
        taxBlock: values?.taxBlock,
        // additionalParcelDesc: values?.additionalParcelDesc,
        latitude: values?.latitude,
        longitude: values?.longitude,
        streetName: values?.streetName,
        streetTypeOrSuffix: values?.streetTypeOrSuffix,
        county: values?.county,
        country: values?.country,
        city: values?.city,
        state: values?.state,
        zipCode: values?.zipCode,
        // postalCode: values?.postalCode,
        subdivision: values?.Subdivision?.toString(),
        taxLegalDescription: values?.taxLegalDescription,
        parcelNumber: values?.parcelNumber,
        // additionalParcels: values?.addionalParecel,
        mlsArea: values?.mlsArea,
        etj: values?.etj,
        femaFloodPlain: values?.femaFloodPlain,
        streetNumber: values?.streetNumber?.toString()
    },
    schoolInformation: {
        outOfStateSchoolDistrict: values?.outOfStateSchoolDistrict?.toString(),
        elementryOther: values?.elementaryOther,
        middleOrJuniorOther: values?.middleJuniorOther,
        highSchoolOther: values?.highSchoolOther,
        schoolDistrict: values?.schoolDistrict,
        elementy: values?.elementary?.toString(),
        middleOrJunior: values?.middleJunior?.toString(),
        highSchool: values?.highSchool
    },
    generalInformation: {
        alsoListedAs: values?.alsoListedAs,
        otherLevelBeds: values?.otherLevelBeds?.toString(),
        builderName: values?.builderName,
        distanceToWaterAccess: values?.distanceToWaterAccess,
        waterBodyName: values?.waterBodyName,
        mainLevelBedrooms: values?.mainLevelBedrooms?.toString(),
        yearBuilt: values?.yearBuilt?.toString(),
        bathroomsFull: values?.bathroomsFull,
        bathroomsHalf: values?.bathroomsHalf,
        living: values?.living,
        dining: values?.dining,
        livingArea: values?.livingArea,
        garageSpaces: values?.garageSpaces?.toString(),
        parkingTotal: values?.parkingTotal?.toString(),
        parkingFeeFrom: values?.parkingFeeFrom,
        parkingFeeTo: values?.parkingFeeTo,
        parkingFeeFrequency: values?.parkingFeeFrequency,
        lotSizeAcres: values?.lotSizeAcres?.toString(),
        lotDimensions: values?.lotDimensions?.toString(),
        // yearBuiltSource: values?.yearBuiltSource,
        livingAreaSource: values?.livingAreaSource,
        // ownershipType: values?.ownershipType,
        directionFaces: values?.directionFaces,
        levels: values?.levels,
        propertySubType: values?.propertySubTypes,
        propertyCondition: values?.propertyCondition,
        constructionMaterials: values?.constructionMaterials,
        parkingFeatures: values?.parkingFeatures,
        foundationDetails: values?.foundationDetails,
        roof: values?.roof,
        view: values?.view,
        lotFeatures: values?.lotFeatures,
        waterfrontFeatures: values?.waterfrontFeatures,
        flooring: values?.flooring,
        restrictions: ['none'] || values?.restrictions,
        unitStyle: values?.unitStyle,
        complexName: values?.complexName,
        complex_id: values?.complex_id,
        unitsInComplex: values?.unitsInComplex,
        floorPlanName: values?.floorPlanName,
        smokingInside: values?.smokingInside,
        moveInSpecial: values?.moveInSpecialYN,
        moveInSpecialDescription: values?.moveInSpecialDescription
    },
    additionalInformation: {
        communityWebSite: values?.communityWebSite,
        guestBeds: values?.guestBeds?.toString(),
        guestFullBaths: values?.guestFullBaths,
        guestHalfBaths: values?.guestHalfBaths,
        fireplaces: values?.fireplaces,
        interiorFeatures: values?.interiorFeatures,
        exteriorFeatures: values?.exteriorFeatures,
        appliances: values?.appliances,
        flooring: values?.flooring,
        windowFeatures: values?.windowFeatures,
        securityFeatures: values?.securityFeatures,
        accessibilityFeatures: values?.accessibilityFeatures,
        laundryLocation: values?.laundryLocation,
        patioAndPorchFeatures: values?.patioAndPorchFeatures,
        horseAmenities: values?.horseAmenities,
        privatePoolFeatures: values?.privatePoolFeatures,
        fencing: values?.fencing,
        otherStructures: values?.otherStructures,
        guestAccommodations: values?.guestAccommodations,
        communityFeatures: values?.communityFeatures,
        distanceToUtShuttle: values?.distanceToUTShuttle,
        distanceToMetro: values?.distanceToMetro,
        distanceToLightRail: values?.distanceToLightRail,
        spaFeatures: values?.spaFeatures,
        fireplaceFeatures: values?.fireplaceFeatures,
        furnished: values?.furnished,
        appliancesMaintained: values?.appliancesMaintained
    },
    rooms: values?.rooms,
    documentsAndUtilities: {
        // groundwaterConservDistrict: values?.groundwaterConservDistrict,
        disclosures: values?.disclosures,
        documentsAvailable: values?.documentsAvailable,
        utilities: values?.utilities,
        heating: values?.heating,
        cooling: values?.cooling,
        waterSource: values?.waterSource,
        sewer: values?.sewer,
        ownerPays: values?.ownerPays,
        tenantPays: values?.tenantPays,
        meterDescription: values?.meterDescription
    },
    greenEnergy: {
        greenEnergyEfficient: values?.greenEnergyEfficient,
        greenSustainability: values?.greenSustainability,
        greenEnergyBuildingVerifications: values?.greenEnergyVerification
    },
    // financial: {
    //     associationName: values?.associationName,
    //     hoaManagementCo: values?.hOAManagementCo,
    //     associationFee: values?.associationFee,
    //     associationRequirement: values?.associationRequirement,
    //     associationFeeFrequency: values?.associationFeeFrequency,
    //     associationTransferFee: values?.associationTransferFee,
    //     specialAssessment: values?.specialAssessment,
    //     taxAnnualAmount: values?.taxAnnualAmount,
    //     title: values?.title,
    //     preferredTitleCompany: values?.preferredTitleCompany,
    //     associationYN: values?.association,
    //     estimatedTax: values?.estimatedTax,
    //     taxYear: values?.taxYear,
    //     taxAssessedValue: values?.taxAssessedValue,
    //     taxRate: values?.taxRate,
    //     acceptableFinancing: values?.acceptableFinancing,
    //     buyerIncentive: values?.buyerIncentive,
    //     taxExemptions: values?.taxExemptions,
    //     possession: values?.possession,
    //     AssociationFeesInclude: values?.associationFeesInclude
    // },
    howToApply: {
        associationYN: values?.associationYN,
        applicationFee: values?.applicationFee,
        applicationFeePerPerson: values?.applicationFeePerPerson,
        applicationFeePayableTo: values?.applicationFeePayableTo,
        managedBy: values?.managedBy,
        securityDeposit: values?.securityDeposit,
        securityDepositPayableTo: values?.securityDepositPayableTo,
        administrationFee: values?.administrationFee,
        administrationFeePayableTo: values?.administrationFeePayableTo,
        firstMonthRentPayableTo: values?.firstMonthRentPayableTo,
        shortTermPremium: values?.shortTermPremium,
        shortTermPremiumAmount: values?.shortTermPremiumAmount,
        onSiteCompliance: values?.onSiteCompliance,
        renterInsuranceRquired: values?.renterInsuranceRequired,
        minimumLeaveMonths: values?.minimumLeaseMonths,
        maximumLeaveMonths: values?.maximumLeaseMonths,
        availableDate: values?.availableDate ? new Date(values.availableDate).toISOString() : undefined,
        certifiedFunds: values?.certifiedFunds,
        leaseTerm: values?.leaseTerm,
        leaseGuarantorYN: values?.leaseGuarantorYN,
        applicationPolicy: values?.applicationPolicy,
        petAllowed: values?.petsAllowed,
        maxNumberOfPets: values?.maxNumberOfPets,
        petDeposit: values?.petDeposit,
        petDepositPerPet: values?.petDepositPerPet,
        monthlyPetRent: values?.monthlyPetRent,
        monthlyPetRentPerPet: values?.monthlyPetRentPerPet,
        additionalPetFee: values?.additionalPetFee,
        additionalPetFeeDescription: values?.additionPetFeeDescription,
        applicationRequired: values?.applicationRequired,
        oneTimeExpense: values?.oneTimeExpenses,
        recurringExpense: values?.recurringExpenses,
        applicationDriverAddress: values?.applicationDeliverAddress,
        websiteAppLinkPublicView: values?.websiteAppLinkPublicView,
        websiteAppLinkAgentView: values?.websiteAppLinkAgentView,
        sellerContributionYN: values?.sellerContributionsYN,
        intermediary: values?.intermediaryYN,
        rentSpreeOnlineApplicationYN: values?.rentSpreeOnlineApplicationYN,
        commissionType: values?.commissionType,
        commission: values?.commission?.toString()
    },
    showingInformation: {
        accessCode: values?.accessCode,
        showingContactName: values?.showingContactName,
        showingContactPhone: values?.showingContactPhone,
        showingServicePhone: values?.showingServicePhone,
        showingInstructions: values?.showingInstructions,
        occupantType: values?.occupantType,
        ownerName: values?.ownerName,
        lockboxLocation: values?.lockboxLocation,
        lockboxType: values?.lockboxType?.toString(),
        showingRequirements: values?.showingRequirements,
        // showingRequirements: ['values'],
        showingContactType: values?.showingContactType,
        lockboxSerialNumber: values?.lockboxSerialNumber?.toString(),
        managementCompany: values?.managementCompany,
        managementCompanyRep: values?.managementCompanyRep,
        managementCompanyPhone: values?.managementCompanyPhone
    },
    compensationInformation: {
        bonustoBA: values?.bonusToBA,
        bonustoBAAmount: values?.bonusToBAAmount,
        subAgencyCompensationType: values?.subAgencyCompType,
        buyerAgencyCompensationType: values?.buyerAgencyCompType,
        subAgencyCompensation: values?.subAgencyComp,
        buyerAgencyCompensation: values?.buyerAgencyComp,
        dualVariableCompensation: values?.dualVariableComp,
        intermediary: values?.intermediary
    },
    remarksInformation: {
        privateRemarks: values?.privateRemarks,
        syndicationRemarks: values?.syndicationRemarks,
        directions: values?.directions,
        publicRemarks: values?.publicRemarks
    },
    virtualTours: {
        brandedVirtualTourUrl: values?.brandedVirtualTourURL,
        unbrandedVirtualTourUrl: values?.unbrandedVirtualTourURL,
        brandedVideoTourUrl: values?.brandedVideoTourURL,
        unbrandedVideoTourUrl: values?.unbrandedVideoTourURL,
        listingDetailedUrl: values?.listingDetailedURL,
        createAPropertyPanoramaVirtualTour: values?.propertyPanorama
    },
    internetDisplay: {
        internetEntireListingDisplay: values?.internetListingDisplay,
        internetAutomatedValuationDisplay: values?.internetAutomatedValuation,
        internetConsumerComment: values?.internetConsumerComment,
        internetAddressDisplay: values?.internetAddressDisplay,
        listingWillAppearOn: values?.listingWillAppearOn
    },
    agentInformation: {
        listAgentMLSID: values?.listAgentMLSID?.toString(),
        coListAgentMLSID: values?.coListAgentMLSID?.toString(),
        privateRemarksSyndicationRemarks: 'string'
    },
    attributionContact: {
        listingOverride: values?.listingOverride?.toString()
    }
});

export function formatDate(isoDateString) {
    if (!isoDateString) return null; // Return null if the input is falsy (null, undefined, or empty string)
    const date = new Date(isoDateString);
    // const year = date.getFullYear();
    // const month = String(date.getMonth() + 1).padStart(2, '0');
    // const day = String(date.getDate()).padStart(2, '0');

    // return `${year}-${month}-${day}`;
    return date;
}
